import { render, staticRenderFns } from "./edituserinfo.vue?vue&type=template&id=104a0bc8"
import script from "./edituserinfo.vue?vue&type=script&lang=js"
export * from "./edituserinfo.vue?vue&type=script&lang=js"
import style0 from "./edituserinfo.vue?vue&type=style&index=0&id=104a0bc8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports